import { useMemo } from 'react'
import { ModalDialog } from '../../../../../../shared/component/modal-dialog'
import { ButtonPrimary } from '../../../../../../shared/component/button'
import { InviteSkipped } from './invite-skipped'

// skipped: the members the bulk invite skipped (already members), listed
// with a link to their page; onNavigate closes the modal before following it.
export const InviteModalProgress = ({ target, progress, skipped, onContinue, onNavigate }) => {
  const value = useMemo(() => `${Math.floor(progress)}%`, [progress])
  const disabled = useMemo(() => progress !== 100, [progress])

  return (
    <ModalDialog header="Add User Progress" target={target} backdropStatic>
      <div>
        <div className="progress" role="progressbar">
          <div className="progress-bar" style={{ width: value }}>
            {value}
          </div>
        </div>
      </div>
      <InviteSkipped skipped={skipped} onNavigate={onNavigate} />
      <div className="m-1">
        <ButtonPrimary text="Continue" disabled={disabled} onClick={onContinue} />
      </div>
    </ModalDialog>
  )
}
